var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tr',{class:_vm.b()},[_c('td',[_c('b',[_vm._v("("+_vm._s(_vm.referral.vatType)+")")]),_vm._v("  "+_vm._s(_vm.referral.vat))]),_c('td',[_c('a',{attrs:{"href":_vm.emailLink}},[_vm._v(_vm._s(_vm.referral.email))])]),_c('td',{staticClass:"test"},[_c('a',{attrs:{"href":_vm.mobileCallLink}},[_vm._v(_vm._s(_vm.referral.mobile))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }